var _rect, _rect2, _path, _path2, _path3, _rect3, _text, _text2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGabrielProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 900,
    viewBox: "0 0 1200 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 900,
    fill: "#191919"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 900,
    fill: "url(#paint0_linear_1_3)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112 796L780 324L1200 604V900H112V796Z",
    fill: "#A11F18",
    fillOpacity: 0.96
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 610L412 312L610 396L0 836V610Z",
    fill: "#8C1A15",
    fillOpacity: 0.92
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M990 0H1200V408L864 188L990 0Z",
    fill: "#F0E5DE",
    fillOpacity: 0.06
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 104,
    width: 446,
    height: 446,
    stroke: "white",
    strokeWidth: 18,
    strokeOpacity: 0.86
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 758,
    fill: "white",
    fontFamily: "Roboto Slab, serif",
    fontSize: 150,
    fontWeight: 700
  }, "GC")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 816,
    fill: "#F6E9E2",
    fontFamily: "Roboto, sans-serif",
    fontSize: 34,
    letterSpacing: 4
  }, "ARQUITETURA E ENGENHARIA")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3",
    x1: 74,
    y1: 84,
    x2: 1128,
    y2: 794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2B2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGabrielProfile);
export default __webpack_public_path__ + "static/media/gabriel-profile.92bf070990f55b8a47b8cc519db1dff9.svg";
export { ForwardRef as ReactComponent };